module.exports = __webpack_public_path__ + "img/br.6827f261.png";